import React from 'react'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'

import WalletSummariesIndexContainer from './WalletSummariesIndexContainer'

class WalletSummaryIndexPage extends React.Component {
    componentDidMount() {
        document.title = 'Wallet Summaries | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                        { path: '/wallet_summaries', name: 'Wallet Summaries' }
                    ]}>
                    <ContentLayout>
                        <WalletSummariesIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default WalletSummaryIndexPage
